import { Component, Input, ViewEncapsulation } from '@angular/core';
import { PatientDocumentsMode } from '../../models/patient-documents-mode';

@Component({
  selector: 'app-patient-retrieve-documents',
  templateUrl: './patient-retrieve-documents.component.html',
  styleUrls: ['./patient-retrieve-documents.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class PatientRetrieveDocumentsComponent {
  /** When embedded in a parent (e.g. patient-overview), pass patient ID (Firestore doc id or caseName). */
  @Input() patientID: string | null = null;
  /** When embedded in a parent, pass the patient object to avoid loading from Firestore. */
  @Input() patientFromParent: any = null;

  mode: PatientDocumentsMode = 'retrieve';
}
